import { render, staticRenderFns } from "./PaintImage.vue?vue&type=template&id=5b1929c8&scoped=true"
import script from "./PaintImage.vue?vue&type=script&lang=ts"
export * from "./PaintImage.vue?vue&type=script&lang=ts"
import style0 from "./PaintImage.vue?vue&type=style&index=0&id=5b1929c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1929c8",
  null
  
)

export default component.exports